import React, { useState, useEffect } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { ThemMoiTaiSan2 } from "../../components/CommonComponent/ThemMoiTaiSan/index2";
import { useSelector, useDispatch } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import { formatNumber } from "utils/currencyFormat";
import { formatCurrency2 } from "utils/currencyFormat";
export const TableDanhSachTaiSan = ({ dsQuyen = [] }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const listTaisanFull = useSelector((state) => state.listTaiSanFull); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchTaiSan); //dataSearchTaiSan dinh nghia o rootreducer
  // const initlistTaisanFull = {
  //   List: [],
  //   TongBanGhi: 0,
  // };

  //const [listTaisanFull, SetDSTaiSan] = useState(initlistTaisanFull);
  // const initdatasearchtaisan = {
  //   tentaisan: "",
  //   tenkhachhang: "",
  //   kho: 0,
  //   trangthai: -1,
  //   tinhtrang: 0,
  //   ghichu: "",
  //   pageIndex: 1,
  //   pageSize: 2,
  // };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("Type");
    if (status === "7") {
      dataSearch.trangthai = "7";
      dispatch(getListTaiSan(dataSearch));
    } else {
      dispatch(getListTaiSan(dataSearch));
    }
  }, []);

  const loadTaiSan = () => {
    getListTaiSan(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      }),
    );
    dispatch(getListTaiSan(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    dispatch(updateDataSearch(data));
    dispatch(getListTaiSan(data));
    loadTaiSan();
  };
  const TotalQuantity = listTaisanFull.TongBanGhi;

  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div
            className="iconbutton-new  mb-1"
            style={{
              position: "sticky",
              padding: "2px",
              top: "12.3rem",
              zIndex: "999",
              background: "#FFFFFF",
            }}
          >
            <div className="row">
              <div className="col-sm-12 col-md-9">
                {dsQuyen.includes("danhsachtaisan_themmoitaisan") && (
                  <button
                    type="button"
                    className="btn btn-border-new"
                    onClick={handleShow}
                  >
                    <img
                      src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                      style={{ paddingBottom: "5px" }}
                    />{" "}
                    Thêm mới
                  </button>
                )}
              </div>{" "}
            </div>
          </div>

          <div className="Left808x200 Table-main-new ">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listTaisanFull.getListTaiSanLoading ? "is-active" : "")
                }
              ></div>
            </div>
            <div className="table-mobile sticky-table-bh table-mobile-hover">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers"
                  style={{
                    position: "sticky",
                    padding: "2px",
                    top: "15.4rem",
                    zIndex: "999",
                    background: "#FFFFFF",
                    padding: "1px 0",
                  }}
                >
                  <div className="custom-table-header flex-basis-5 flex-basis-6-npt flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listTaisanFull.TongBanGhi} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-16 flex-basis-13-npt flex-basis-14-sm">
                    <p className="text-center">Mã tài sản</p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-10-npt flex-basis-13-sm">
                    <p className="text-center">Tên tài sản</p>
                  </div>
                  <div className="custom-table-header flex-basis-13 flex-basis-9-npt flex-basis-11-sm">
                    <p className="text-center">Kho</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-11-2-npt flex-basis-9-sm">
                    <p className="text-center">Hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-12-8-npt flex-basis-12-sm">
                    <p className="text-left">Khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-npt flex-basis-12-sm">
                    <p className="text-right">
                      Số tiền <br />
                      <span
                        className="color-xanh-bold"
                        title={formatNumber(listTaisanFull.TongSoTienVay)}
                      >
                        {formatCurrency2(listTaisanFull.TongSoTienVay)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-npt flex-basis-11-sm">
                    <p className="tab-header text-center">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-16-npt flex-basis-12-sm">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body" style={{ width: "100%" }}>
                  <ContentTable
                    listtaisan={listTaisanFull.List}
                    dsQuyen={dsQuyen}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.pageIndex}
            pageSize={dataSearch.pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
      {show && <ThemMoiTaiSan2 show={show} onHide={handleClose} />}
    </>
  );
};
